<header style="overflow: hidden !important" class="template-header">
    <!-- Google Tag Manager -->
    <script>
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-N73Z6Q5S');
    </script>
    <!-- End Google Tag Manager -->

    <div class="header-top-note">
      <div
        class="container-fluid header-topbar d-none d-md-none d-lg-block mt-50"
        style="position: fixed; margin-top: -9px !important; height: 53px">
        <div class="container container-1450">
          <div
            class="row align-items-center justify-content-between"
            style="justify-content: flex-end !important; margin: -13px; margin-left: 1.5cm !important">
            <div class="col-lg-10">
              <ul class="topbar-menu" style="margin-top: 10px">
                <li
                  routerLinkActive=" active"
                  [routerLinkActiveOptions]="{exact: true}"
                  style="padding-right: 100px !important"
                  class="cursor-pointer">
                  <a
                    [routerLink]="'/portal/saude'"
                    (click)="navigateToSection('saude')"
                    [class.selected]="currentSection === 'saude'"
                    class="font-size-menu"
                    style="color: grey">
                    Planos de Saúde
                  </a>
                </li>
                <li
                  routerLinkActive=" active"
                  [routerLinkActiveOptions]="{exact: true}"
                  style="padding-right: 100px !important"
                  class="cursor-pointer">
                  <a
                    [routerLink]="'/portal/odonto'"
                    (click)="navigateToSection('odonto')"
                    [class.selected]="currentSection === 'odonto'"
                    style="color: grey"
                    class="nohover font-size-menu">
                    Planos Odontológicos
                  </a>
                </li>
                <li routerLinkActive=" active" [routerLinkActiveOptions]="{exact: true}">
                  <a
                    [class.selected]="currentSection === 'seguro'"
                    (click)="navigateToSection('seguro')"
                    style="color: grey"
                    class="font-size-menu">
                    Seguros
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <app-header></app-header>

  <body>
    <!-- Google Tag Manager (noscript) -->
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-N73Z6Q5S"
        height="0"
        width="0"
        style="display: none; visibility: hidden"></iframe>
    </noscript>
    <!-- End Google Tag Manager (noscript) -->
    <!-- saude -->
    <!-- ------------------------------------------------------------------------------------------------------------------ -->
    <!-- NOVO BANNER IRIS START    -->
    <!-- <div class=" container" >
      <div class="banner " style=" margin-top: 9%; ">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-7 col-sm-12 col-lg-7 iris-mr " style=" "><img src="../../../../../assets/app-assets/images/fotografias/varejo/banner-iris.png" alt="Consultora"
                class="consultora img-fluid">
              </div>
              <div class="col-md-5 col-sm-12 col-lg-5">

            <div class=" text-section margin-text order-md-2 mobile" style="      ">
              <h1 class="title">PROCURANDO UM <p >PLANO DE SAÚDE</p> COM ÓTIMA COBERTURA E BAIXOS REAJUSTES?</h1>
              <p class="subtitle">Descubra agora a melhor opção para você e sua família.</p>
              <div class="btn-group">

                <button style="background-color: #407590 !important;" (click)="simularPorOperadora(template, menorValorSaude?.IdOperadora, menorValorSaude?.NomeOperadora, 'saude')" type="button" class="btn btn-info round box-shadow-4 btn-simule"><span>SIMULE E COMPRE</span></button>
                <a href="https://api.whatsapp.com/send?phone=551136602000&text=oi" target="_blank">
                <button type="button" class="btn btn-float  btn-success round box-shadow-4"><span>FALE COM UM CONSULTOR</span></button>
                </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
        <section class="cards-section    container-1300">

        <div class="container">
          <div class="scroll-card-iris cards">
              <div class="card round-top">
                <div class="card-body">
                  <h5 class="card-title">Reajustes Contratuais Abaixo do Mercado</h5>
                  <p class="card-text">Anos de experiência cuidando da sua saúde.</p>

                </div>
              </div>

              <div class="card round-top">
                <div class="card-body">
                  <h5 class="card-title">Tradição e Confiança</h5>
                  <p class="card-text">Anos de experiência cuidando da sua saúde.</p>

                </div>
              </div>
              <div class="card round-top">
                <div class="card-body">
                  <h5 class="card-title">Cobertura Completa</h5>
                  <p class="card-text">Atendimento médico de qualidade quando você mais precisa.</p>

                </div>
              </div>
          </div>
        </div>
      </section>
    </div> -->
    <!-- NOVO BANNER IRIS END -->
    <!-- ------------------------------------------------------------------------------------------------------------------ -->
    <!-- NOVO DE NOVO BANNER IRIS START    -->
    <!-- <ng-container>
        <div class="row campo-superior">
            <div class="col-md-6  campo-img">
                <img src="../../../../../assets/app-assets/images/fotografias/varejo/iris-corpo-todo.png" alt="Consultora" class="consultora img-fluid img-left-sticky">
            </div>

            <div class="col-md-6 col-sm-12 campo-texto">
                <div class="text-section margin-text order-md-2 mobile">
              <h1 class="title">BUSCANDO UM <p style="color: #023341 !important;">PLANO DE SAÚDE</p> COM AMPLA COBERTURA E BAIXOS REAJUSTES?</h1>
              <p class="subtitle" style="color: #023341 !important;">Descubra o preço do seu plano informando apenas sua <b>idade, cidade e profissão</b>.</p>
              <div class="btn-group" style="display: flex;">

                <button style="background-color: #407590 !important;" (click)="simularPorOperadora(template, menorValorSaude?.IdOperadora, menorValorSaude?.NomeOperadora, 'saude')" type="button" class="btn template-btn round box-shadow-4 btn-simule mb-3" style=" height: 4rem !important; margin-bottom: 29px !important;
                width: 15rem !important;
            "><span>SIMULAR AGORA</span></button>
                <a href="https://api.whatsapp.com/send?phone=551136602000&text=oi" target="_blank">
                <button type="button" class="btn btn-float btn-simule btn-success round box-shadow-4 col-sm-12" style="  height: 4rem !important;
                width: 15rem !important;"><span>FALE COM UM CONSULTOR</span></button>
                </a>
                </div>

                    <div class="row wizard-content mt-5">

                    </div>
                </div>
            </div>
        </div>
        <section class="cards-section-novo-banner-iris  d-flex justify-content-center align-items-center">
          <div class="container">
            <div class="scroll-card-iris cards">
                <div class="card round-top">
                  <div class="card-body">
                    <h5 class="card-title">Reajustes Contratuais Abaixo do Mercado</h5>
                    <p class="card-text">Proteja seu bolso com aumentos menores.</p>

                  </div>
                </div>

                <div class="card round-top">
                  <div class="card-body">
                    <h5 class="card-title">Tradição e Confiança</h5>
                    <p class="card-text">Anos de experiência cuidando da sua saúde.</p>

                  </div>
                </div>
                <div class="card round-top">
                  <div class="card-body">
                    <h5 class="card-title">Cobertura Completa</h5>
                    <p class="card-text">Atendimento médico de qualidade quando você mais precisa.</p>

                  </div>
                </div>
            </div>
          </div>
        </section>
    </ng-container> -->

    <app-banner-simulador-preco></app-banner-simulador-preco>

    <!-- <ng-container>
      <div class="row" style="margin-top: 98px;">
          <div class="col-md-6 col-12 d-flex justify-content-center mb-3 mb-md-0">
              <img src="../../../../../assets/app-assets/images/fotografias/varejo/iris-corpo-todo.png" alt="Consultora" class="consultora img-fluid img-left-sticky">
          </div>

          <div class="col-md-6 col-12 text-center text-md-start campo-texto">
              <div class="text-section margin-text order-md-2 mobile">
                  <h1 class="title">BUSCANDO UM <p>PLANO DE SAÚDE</p> COM AMPLA COBERTURA E BAIXOS REAJUSTES?</h1>
                  <p class="subtitle">Descubra o preço do seu plano informando apenas sua <strong>idade, cidade e profissão</strong>.</p>
                  <div class="btn-group">
                      <button style="background-color: #407590 !important;" (click)="simularPorOperadora(template, menorValorSaude?.IdOperadora, menorValorSaude?.NomeOperadora, 'saude')" type="button" class="btn btn-info round box-shadow-4 btn-simule">
                          <span>SIMULAR AGORA</span>
                      </button>
                      <a href="https://api.whatsapp.com/send?phone=551136602000&text=oi" target="_blank">
                          <button type="button" class="btn btn-float btn-success round box-shadow-4">
                              <span>FALE COM UM CONSULTOR</span>
                          </button>
                      </a>
                  </div>

                  <div class="row wizard-content mt-5"></div>
              </div>
          </div>
      </div>

      <section class="cards-section-novo-banner-iris d-flex justify-content-center align-items-center">
          <div class="container">
              <div class="scroll-card-iris cards">
                  <div class="card round-top">
                      <div class="card-body">
                          <h5 class="card-title">Reajustes Contratuais Abaixo do Mercado</h5>
                          <p class="card-text">Proteja seu bolso com aumentos menores.</p>
                      </div>
                  </div>

                  <div class="card round-top">
                      <div class="card-body">
                          <h5 class="card-title">Tradição e Confiança</h5>
                          <p class="card-text">Anos de experiência cuidando da sua saúde.</p>
                      </div>
                  </div>

                  <div class="card round-top">
                      <div class="card-body">
                          <h5 class="card-title">Cobertura Completa</h5>
                          <p class="card-text">Atendimento médico de qualidade quando você mais precisa.</p>
                      </div>
                  </div>
              </div>
          </div>
      </section>
  </ng-container> -->

    <!-- NOVO DE NOVO BANNER IRIS END -->

    <!-- card medicos-->
    <section class="doctors-section section-gap bg-cards-only-mobile">
      <div class="container">
        <div class="row justify-content-center latest-blog-loop bg-iris-card">
          <div class="col-lg-4 col-md-6">
            <div class="doctor-box-one mt-30 box-shadow-5 round mt-30 card-heigth" style="height: 80% !important">
              <div class="doctor-photo">
                <img
                  style="width: 50% !important"
                  src="../../../../../assets/app-assets/images/icones-geia/varejo/medica.png"
                  alt="Image" />
              </div>
              <div class="blog-content mt-2">
                <h4 class="blog-title" style="margin: 10px; text-align: left">
                  <span class="desc-card-doctor">
                    OS MELHORES
                    <b class="bold-azul-geia">MÉDICOS E ESPECIALISTAS</b>
                  </span>
                </h4>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="doctor-box-one mt-30 box-shadow-5 round mt-30 card-heigth" style="height: 80% !important">
              <div class="doctor-photo">
                <img
                  style="width: 80% !important"
                  src="../../../../../assets/app-assets/images/icones-geia/varejo/hospital.png"
                  alt="Image" />
              </div>
              <div class="blog-content mt-2">
                <h4 class="blog-title" style="margin: 10px; text-align: left">
                  <span class="desc-card-doctor">
                    AMPLA REDE CREDENCIADA DE
                    <b class="bold-azul-geia">HOSPITAIS E CLÍNICAS</b>
                  </span>
                </h4>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="doctor-box-one mt-30 box-shadow-5 round mt-30 card-heigth" style="height: 80% !important">
              <div class="doctor-photo">
                <img
                  style="width: 65% !important"
                  src="../../../../../assets/app-assets/images/icones-geia/varejo/mapa-region.png"
                  alt="Image" />
              </div>
              <div class="blog-content mt-2">
                <h4 class="blog-title" style="margin: 10px; text-align: left">
                  <span class="desc-card-doctor">
                    PLANOS REGIONAIS
                    <b class="bold-azul-geia">E NACIONAIS</b>
                  </span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  -->
    <!-- carousel headerr -->

    <!-- <section
      class="about-section section-gap bg-white"
      style="padding-bottom: 35px"
    >
      <app-auto-slider-bottom
        [receberSliderItems]="sliderItemsOdonto"
      ></app-auto-slider-bottom>
    </section> -->
    <!-- Geia Team -->
    <app-geia-team></app-geia-team>

    <!--  -->
    <!-- EINSTEIN -->
    <app-einstein-conecta></app-einstein-conecta>
    <!--  -->

    <!-- ODNONTO -->
    <section id="odonto" class="video-section bg-color-white bg-mobile">
      <div class="row">
        <div class="col-md-12 campo-img">
          <img
            src="../../../../../assets/app-assets/images/fotografias/varejo/banner-odonto.png"
            alt="Consultora"
            class="consultora img-fluid-odonto img-left-sticky" />
        </div>
        <!-- Card -->
        <div class="row justify-content-center align-items-center card-simule-mobile">
          <div class="col-md-8 col-sm-12 odonto-tablet">
            <div class="bg-white p-3 mt-50 card-odonto mt-90 padding-card-odonto-mobile padding-tablet">
              <div class="mt-div-banner-title-on-mobile">
                <div class="text-center container margin-top-card-odonto">
                  <h2 class="title-card-master title-banner title preto-geia l-s-0">PLANOS</h2>
                  <h2 class="title-card-master title-banner title preto-geia l-s-0">
                    <span class="sub-title-card-master title sub-title-banner l-s-0" style="color: #407590 !important">
                      ODONTOLÓGICOS
                    </span>
                  </h2>
                  <span class="desc-price-top">A partir de</span>
                  <h2 class="desc-title-banner price-master">
                    {{ valorAntesDoPontoOdonto }}
                    <span class="duration cent-value">,{{ valorDepoisDoPontoOdonto }}</span>
                  </h2>
                  <div class="text-center" style="margin-top: -9px">
                    <span class="duration desc-mount">por mês</span>
                  </div>
                  <div>
                    <p class="desc-title-banner mt-1 preto-geia desc-bottom mb-2">
                      Plano Nacional Essencial Plus
                      {{ (menorValorOdonto && menorValorOdonto!.NomeOperadora) || 'UNIMED ODONTO' }}
                      sem TELEORIENTAÇÃO EINSTEIN CONECTA. Validade até
                      {{ (menorValorOdonto && menorValorOdonto!.Validade) || '' }}
                      ANS:
                      {{ (menorValorOdonto && menorValorOdonto!.Ans) || '469.840/13-1' }}
                    </p>
                  </div>

                  <button
                    type="button"
                    (click)="
                      simularPorOperadora(
                        template,
                        menorValorOdonto?.IdOperadora,
                        menorValorOdonto?.NomeOperadora,
                        'odonto'
                      )
                    "
                    class="btn btn-info cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1">
                    <b>SIMULE E COMPRE</b>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- carousel headerr -->

    <!-- <section class="spikes"></section> -->
    <!-- <section
      class="about-section spikes mt-5 bg-white secao-auto-slider-botton"
      style="padding-bottom: 51px; margin-top: 4% !important"
    > -->
    <!-- <app-auto-slider-bottom
        [receberSliderItems]="sliderItemsOdonto"
      ></app-auto-slider-bottom> -->
    <!-- </section> -->

    <!--  -->

    <!-- SEGURO -->
    <ng-template #template>
      <div class="modal-body text-center">
        <app-politica-privacidade></app-politica-privacidade>
      </div>
    </ng-template>

    <section id="seguro">
      <app-seguros></app-seguros>
    </section>
    <div class="mt-blog-mobile">
      <app-email-contact></app-email-contact>
    </div>
    <app-nexus-chat></app-nexus-chat>
    <app-portal-footer></app-portal-footer>

    <!-- Google Tag Manager (noscript) -->
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-N73Z6Q5S"
        height="0"
        width="0"
        style="display: none; visibility: hidden"></iframe>
    </noscript>
    <!-- End Google Tag Manager (noscript) -->
  </body>
